// The languages a participant can speak and hear. One row per language.
//
// Adding a language (ADR 001, "Adding a language"):
// 1. a row here (code = the vm.lang value, the language's own name);
// 2. its row in LANGUAGES in agent/interpreter/languages.py (speech recognition and voice);
// 3. its code in LANGUAGES in token/.env (and the default in token/lib/config.js);
// 4. optionally a UI catalog in src/i18n/ (without one the UI shows in English).
// scripts/check-protocol.mjs checks that 1-3 list the same codes.

export interface Language {
  /** BCP 47 primary language subtag; the value of the vm.lang attribute. */
  readonly code: string;
  /** The language's name in itself, shown in the language picker. */
  readonly nativeName: string;
  readonly dir: 'ltr' | 'rtl';
}

export const LANGUAGES = [
  { code: 'tr', nativeName: 'Türkçe', dir: 'ltr' },
  { code: 'en', nativeName: 'English', dir: 'ltr' },
] as const satisfies readonly Language[];

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'tr';

export function isLanguageCode(value: unknown): value is LanguageCode {
  return typeof value === 'string' && LANGUAGES.some((language) => language.code === value);
}

export function languageInfo(code: LanguageCode): Language {
  return LANGUAGES.find((language) => language.code === code) ?? LANGUAGES[0];
}

/** The first of the browser's preferred languages that is in the table ("en-GB" means "en"). */
export function languageFromPreferences(preferred: readonly string[]): LanguageCode {
  for (const tag of preferred) {
    const primary = tag.trim().toLowerCase().split(/[-_]/)[0];
    if (isLanguageCode(primary)) return primary;
  }
  return DEFAULT_LANGUAGE;
}
